import React from "react";

const photos = [
  {
    url: "https://customer-assets.emergentagent.com/job_schaefer-services/artifacts/je91iggj_IMG_0375.jpg",
    title: "Site Prep & Hauling",
    tag: "Dirt Work",
    span: "md:col-span-8 md:row-span-2",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_schaefer-services/artifacts/cms98uli_IMG_0765.jpg",
    title: "Drainage Grading & Front Yard",
    tag: "Grading",
    span: "md:col-span-4",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_schaefer-services/artifacts/i42fqa44_IMG_2633.jpeg",
    title: "Custom Wood Gate",
    tag: "Fence Work",
    span: "md:col-span-4",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_schaefer-services/artifacts/585hpeg0_20210517_125727~2_Original.jpeg",
    title: "Stained Cedar Pergola",
    tag: "Pergolas",
    span: "md:col-span-6",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_schaefer-services/artifacts/8fp768xw_IMG_2630.jpeg",
    title: "Privacy Fence & Backyard Access",
    tag: "Fence Work",
    span: "md:col-span-6",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_schaefer-services/artifacts/w7r0rso6_IMG_1926.jpg",
    title: "Shop Pad & Drive Grading",
    tag: "Grading",
    span: "md:col-span-4",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_schaefer-services/artifacts/2qoyhqbm_IMG_1129.jpg",
    title: "Building Drainage Cut",
    tag: "Grading",
    span: "md:col-span-4",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_schaefer-services/artifacts/l73piqdw_IMG_0768.jpg",
    title: "Shop Driveway",
    tag: "Driveway Construction",
    span: "md:col-span-4",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_schaefer-services/artifacts/4i18oxku_IMG_0867.jpg",
    title: "Trenching & Utilities",
    tag: "General Dirt Work",
    span: "md:col-span-6",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_schaefer-services/artifacts/nmqftl55_IMG_1008%20-%20Copy.jpg",
    title: "Commercial Trenching",
    tag: "Dirt Work / Utilities",
    span: "md:col-span-6",
  },
];

export default function Portfolio() {
  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="bg-[#EAEAE0] py-24 md:py-32 border-b border-[#C4C4B5]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <div className="uppercase text-xs tracking-[0.25em] font-bold text-[#E5231A] mb-4">
              Recent Work
            </div>
            <h2
              data-testid="portfolio-heading"
              className="font-display font-black uppercase tracking-tighter text-[#111110] text-4xl sm:text-5xl md:text-6xl leading-[0.95]"
            >
              Real Jobs.
              <br />
              Real Texas Dirt.
            </h2>
          </div>
          <p className="max-w-md text-base md:text-lg text-[#595955] leading-relaxed">
            A few recent projects across Abilene and the surrounding area —
            land cleared, pads graded, drives built, and buildings standing.
          </p>
        </div>

        <div
          data-testid="portfolio-grid"
          className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6"
        >
          {photos.map((p, i) => (
            <figure
              key={i}
              data-testid={`portfolio-item-${i}`}
              className={`relative group overflow-hidden border border-[#111110] bg-[#111110] ${p.span}`}
            >
              <img
                src={p.url}
                alt={p.title}
                loading="lazy"
                className="w-full h-full object-cover aspect-[4/3] md:aspect-auto md:min-h-[320px] group-hover:scale-105 transition-transform duration-700 ease-out"
              />
              <figcaption className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-black/80 via-black/30 to-transparent">
                <div className="uppercase text-[10px] tracking-[0.3em] font-bold text-[#E5231A]">
                  {p.tag}
                </div>
                <div className="mt-1 font-display font-extrabold uppercase text-lg md:text-xl text-[#F4F4EB]">
                  {p.title}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
